const overlay = document.getElementById('builder-modal-overlay');
let activeModal = null;

function openModal(modalId) {
  overlay.classList.add('active');
  document.querySelectorAll('.custom-modal').forEach(m => m.classList.remove('active'));
  activeModal = document.getElementById(modalId);
  if (activeModal) activeModal.classList.add('active');
  document.body.style.overflow = 'hidden'; 
}

function closeModals() {
  overlay.classList.remove('active');
  if(activeModal) activeModal.classList.remove('active');
  document.body.style.overflow = ''; 
  calculateTotal(); 
}

function selectCard(labelElement) {
  const siblings = labelElement.parentElement.querySelectorAll('.selection-card');
  siblings.forEach(s => s.classList.remove('selected'));
  labelElement.classList.add('selected');
  calculateTotal(true); 
}

function selectFabricModal(labelElement) {
  const siblings = labelElement.parentElement.querySelectorAll('.fabric-grid-item');
  siblings.forEach(s => s.classList.remove('selected'));
  labelElement.classList.add('selected');
  calculateTotal(true);
}

function applyFabricSelection() {
  const selectedRadio = document.querySelector('input[name="temp-fabric"]:checked');
  if (selectedRadio) selectFabric(selectedRadio.value); 
  closeModals();
}

function selectFabric(colorName) {
  const finalFabricEl = document.getElementById('final-fabric');
  if (finalFabricEl) finalFabricEl.value = colorName;
  
  const inlineNameDisplay = document.getElementById('inline-fabric-name');
  if (inlineNameDisplay) inlineNameDisplay.innerText = colorName;
  
  const sampleLink = document.getElementById('dynamic-sample-link');
  if (sampleLink) sampleLink.innerText = `Order a FREE ${colorName.toLowerCase()} sample (1/3)`;

  document.querySelectorAll('.swatch-circle[data-color]').forEach(circle => {
    if (circle.getAttribute('data-color') === colorName) circle.classList.add('active');
    else circle.classList.remove('active');
  });

  const radios = document.querySelectorAll('input[name="temp-fabric"]');
  const matchingModalRadio = Array.from(radios).find(r => r.value === colorName);
  
  if (matchingModalRadio) {
    matchingModalRadio.checked = true;
    document.querySelectorAll('.fabric-grid-item').forEach(item => item.classList.remove('selected'));
    matchingModalRadio.closest('.fabric-grid-item').classList.add('selected');
  }

  calculateTotal();
  filterGallery(colorName);
}

// --- NEW: ADVANCED FABRIC LOGIC ---
function selectAdvancedFabric(type, colorName) {
  const finalInput = document.getElementById('final-fabric-' + type);
  if (finalInput) finalInput.value = colorName;
  
  const summaryDisplay = document.getElementById('summary-fabric-' + type);
  if (summaryDisplay) summaryDisplay.innerText = colorName;

  document.querySelectorAll('.swatch-circle.' + type + '-swatch').forEach(circle => {
    if (circle.getAttribute('data-color') === colorName) circle.classList.add('active');
    else circle.classList.remove('active');
  });

  const radios = document.querySelectorAll('input[name="temp-fabric-' + type + '"]');
  const matchingModalRadio = Array.from(radios).find(r => r.value === colorName);
  
  if (matchingModalRadio) {
    matchingModalRadio.checked = true;
    document.querySelectorAll('#modal-fabric-' + type + ' .fabric-grid-item').forEach(item => item.classList.remove('selected'));
    matchingModalRadio.closest('.fabric-grid-item').classList.add('selected');
  }

  calculateTotal();
  if (type === 'primary') filterGallery(colorName);
}

function applyAdvancedFabricSelection(type) {
  const selectedRadio = document.querySelector('input[name="temp-fabric-' + type + '"]:checked');
  if (selectedRadio) selectAdvancedFabric(type, selectedRadio.value);
  closeModals();
}
// ----------------------------------

function filterGallery(colorName) {
  const galleryItems = document.querySelectorAll('.product__media-item, .thumbnail-list__item, .product-media-container');
  galleryItems.forEach(item => {
    const img = item.querySelector('img');
    if (img && img.alt) {
      const altText = img.alt.trim();
      if (window.allFabricNames && window.allFabricNames.includes(altText)) {
        if (altText === colorName) item.style.display = ''; 
        else item.style.display = 'none'; 
      } 
    }
  });
}

function filterMattresses(sizeText) {
  if (!sizeText) return;
  const targetClean = sizeText.toLowerCase().replace(/[^a-z0-9]/g, '');

  document.querySelectorAll('.mattress-card').forEach(card => {
    const rawTags = card.getAttribute('data-tags') || "";
    const tagArray = rawTags.split('|');

    let hasMatch = false;
    for (let i = 0; i < tagArray.length; i++) {
      const cleanTag = tagArray[i].toLowerCase().replace(/[^a-z0-9]/g, '');
      if (cleanTag === targetClean && cleanTag !== "") {
        hasMatch = true;
        break;
      }
    }

    if (hasMatch) {
      card.style.display = 'flex'; 
    } else {
      card.style.display = 'none'; 
      const radio = card.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        radio.checked = false;
        card.classList.remove('selected');
        
        const noMattress = document.querySelector('input[name="temp-mattress"][value=""]');
        if (noMattress) {
          noMattress.checked = true;
          noMattress.closest('.selection-card').classList.add('selected');
          document.getElementById('final-mattress').value = "";
          document.getElementById('summary-mattress-text').innerText = "No Mattress";
          const imgEl = document.getElementById('summary-mattress-img');
          if(imgEl) imgEl.src = "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
        }
      }
    }
  });
}

function applySelection(type) {
    const selected = document.querySelector(`input[name="temp-${type}"]:checked`);
    if (!selected) { closeModals(); return; }
  
    if (type === 'mattress') {
      document.getElementById('final-mattress').value = selected.value;
      document.getElementById('summary-mattress-text').innerText = selected.getAttribute('data-title');
      const imgUrl = selected.getAttribute('data-img');
      const imgEl = document.getElementById('summary-mattress-img');
      if(imgEl) imgEl.src = imgUrl ? imgUrl : "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
    } else {
      const finalInput = document.getElementById(`final-${type}`);
      if(finalInput) finalInput.value = selected.value;
      
      const summaryText = document.getElementById(`summary-${type}`);
      if(summaryText) summaryText.innerText = selected.value;
  
      if (finalInput && finalInput.getAttribute('data-is-size') === 'true') {
        filterMattresses(selected.value);
      }
    }
    closeModals();
}

function getMatchedNativeVariant(isPreview = false) {
    if (!window.bedVariants) return null;
  
    let searchParams = { option1: null, option2: null, option3: null };
  
    for (let i = 1; i <= 3; i++) {
      const el = document.getElementById(`final-native-${i}`);
      if (el) {
        let val = el.value;
        if (isPreview && activeModal && activeModal.id === `modal-native-${i}`) {
           const checked = document.querySelector(`input[name="temp-native-${i}"]:checked`);
           if(checked) val = checked.value;
        }
        searchParams[`option${i}`] = val;
      }
    }
  
    return window.bedVariants.find(v => {
      if (searchParams.option1 && v.option1 !== searchParams.option1) return false;
      if (searchParams.option2 && v.option2 !== searchParams.option2) return false;
      if (searchParams.option3 && v.option3 !== searchParams.option3) return false;
      return true;
    }) || window.bedVariants[0];
}
  
function calculateTotal(isPreview = false) {
  const matchedVariant = getMatchedNativeVariant(isPreview);
  let basePrice = matchedVariant ? matchedVariant.price : 0;
  
  let baseComparePrice = (matchedVariant && matchedVariant.compare_at_price) ? matchedVariant.compare_at_price : basePrice;

  let extrasTotal = 0;
  
  // --- UPDATED ARRAY ---
  ['fabric', 'fabric-primary', 'fabric-accent', 'fabric-piping', 'headboard', 'siderail', 'assembly', 'mattress'].forEach(type => {
    let selectedRadio = null;
    if (isPreview && activeModal && activeModal.id === `modal-${type}`) {
       selectedRadio = document.querySelector(`input[name="temp-${type}"]:checked`);
    } else {
       const finalValElement = document.getElementById(`final-${type}`);
       if(finalValElement) {
           const finalVal = finalValElement.value;
           const radios = document.querySelectorAll(`input[name="temp-${type}"]`);
           selectedRadio = Array.from(radios).find(r => r.value === finalVal);
       }
    }
    if (selectedRadio && selectedRadio.value !== "") {
       extrasTotal += parseFloat(selectedRadio.getAttribute('data-price') || 0);
    }
  });

  const qtyInput = document.getElementById('bundle-quantity');
  const qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
  
  const finalTotal = (basePrice + extrasTotal) * qty;
  const finalCompareTotal = (baseComparePrice + extrasTotal) * qty; 
  
  document.querySelectorAll('.dynamic-total-price').forEach(el => el.innerText = '£' + finalTotal.toFixed(2));
  
  const compareElements = document.querySelectorAll('.dynamic-compare-price');
  const saveElements = document.querySelectorAll('.dynamic-save-badge');

  if (finalCompareTotal > finalTotal) {
      const saving = finalCompareTotal - finalTotal;
      compareElements.forEach(el => {
          el.innerText = '£' + finalCompareTotal.toFixed(2);
          el.style.display = 'inline-block';
      });
      saveElements.forEach(el => {
          let formattedSaving = saving % 1 === 0 ? saving.toFixed(0) : saving.toFixed(2);
          el.innerText = 'Save £' + formattedSaving;
          el.style.display = 'inline-block';
      });
  } else {
      compareElements.forEach(el => el.style.display = 'none');
      saveElements.forEach(el => el.style.display = 'none');
  }
  
  const amountIn3 = (finalTotal / 3).toFixed(2);
  const amountIn4 = (finalTotal / 4).toFixed(2);
  document.querySelectorAll('.dynamic-price-3').forEach(el => el.innerText = '£' + amountIn3);
  document.querySelectorAll('.dynamic-price-4').forEach(el => el.innerText = '£' + amountIn4);
}

document.addEventListener('DOMContentLoaded', function() {
  calculateTotal(); 
  
  const allNativeInputs = document.querySelectorAll('[id^="final-native-"]');
  allNativeInputs.forEach(input => {
      if (input.getAttribute('data-is-size') === 'true') {
          filterMattresses(input.value);
      }
  });
  
  const qtyInput = document.getElementById('bundle-quantity');
  if(qtyInput) {
      document.getElementById('qty-plus').addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value) + 1; calculateTotal(); });
      document.getElementById('qty-minus').addEventListener('click', () => { 
        if (parseInt(qtyInput.value) > 1) { qtyInput.value = parseInt(qtyInput.value) - 1; calculateTotal(); }
      });
  }

  const addToCartBtn = document.getElementById('custom-add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      const btn = this; const originalText = btn.innerText;
      btn.innerText = 'ADDING...'; btn.disabled = true;

      const globalQty = parseInt(document.getElementById('bundle-quantity').value) || 1;
      let itemsToAdd = [];
      
      const bundleId = 'bed_' + Date.now();
      
      const matchedVariant = getMatchedNativeVariant(false);
      if (matchedVariant) {
        
        let cartProps = { "_bundle_id": bundleId }; 
        
        const fabricEl = document.getElementById('final-fabric');
        if (fabricEl) cartProps["Fabric"] = fabricEl.value;

        // --- NEW: Add Advanced Colors to Payload ---
        const primaryEl = document.getElementById('final-fabric-primary');
        if (primaryEl) cartProps["Primary Colour"] = primaryEl.value;
        
        const accentEl = document.getElementById('final-fabric-accent');
        if (accentEl) cartProps["Accent Colour"] = accentEl.value;
        
        const pipingEl = document.getElementById('final-fabric-piping');
        if (pipingEl) cartProps["Piping Colour"] = pipingEl.value;
        // -----------------------------------------
        
        const headboardEl = document.getElementById('final-headboard');
        if (headboardEl) cartProps["Headboard Height"] = headboardEl.value;
        
        const siderailEl = document.getElementById('final-siderail');
        if (siderailEl) cartProps["Side Rail"] = siderailEl.value;
        
        const assemblyEl = document.getElementById('final-assembly');
        if (assemblyEl) cartProps["Assembly"] = assemblyEl.value;

        const assemblyPostcodeEl = document.getElementById('final-assembly-postcode');
        if (assemblyPostcodeEl && assemblyPostcodeEl.value !== "") {
            cartProps["Assembly Postcode"] = assemblyPostcodeEl.value;
        }

        itemsToAdd.push({
          id: matchedVariant.id,
          quantity: globalQty,
          properties: cartProps
        });
      }
      
      // --- UPDATED ARRAY ---
      ['fabric', 'fabric-primary', 'fabric-accent', 'fabric-piping', 'headboard', 'siderail', 'assembly'].forEach(type => {
        const finalEl = document.getElementById(`final-${type}`);
        if (finalEl) {
            const finalVal = finalEl.value;
            const radios = document.querySelectorAll(`input[name="temp-${type}"]`);
            const radio = Array.from(radios).find(r => r.value === finalVal);
            
            if (radio && radio.getAttribute('data-addon-id')) {
              itemsToAdd.push({ 
                id: parseInt(radio.getAttribute('data-addon-id')), 
                quantity: globalQty,
                properties: { "_bundle_id": bundleId, "_is_addon": "true" }
              });
            }
        }
      });

      const finalMattressEl = document.getElementById('final-mattress');
      if (finalMattressEl && finalMattressEl.value) {
          itemsToAdd.push({ 
            id: parseInt(finalMattressEl.value), 
            quantity: globalQty,
            properties: { "_bundle_id": bundleId, "_is_mattress": "true", "Note": "Paired with bed" }
          });
      }

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: itemsToAdd })
        });
        if (response.ok) { window.location.href = '/cart'; } 
        else {
          const errorData = await response.json();
          alert('Error: ' + errorData.description);
          btn.innerText = originalText; btn.disabled = false;
        }
      } catch(error) {
        console.error('Error:', error);
        btn.innerText = originalText; btn.disabled = false;
      }
    });
  }

  function calculateDeliveryDate(leadDays) {
      let count = 0;
      const currentDate = new Date();
      while (count < leadDays) {
          currentDate.setDate(currentDate.getDate() + 1);
          const dayOfWeek = currentDate.getDay();
          if (dayOfWeek !== 0 && dayOfWeek !== 6) { count++; }
      }
      const options = { weekday: 'short', day: 'numeric', month: 'short' };
      return currentDate.toLocaleDateString('en-GB', options).replace(/,/g, '');
  }

  function updateDeliveryMessage() {
      const leadDaysInput = document.getElementById('delivery-lead-days');
      if (!leadDaysInput) return;
      const leadDays = parseInt(leadDaysInput.value) || 5;
      const formattedDate = calculateDeliveryDate(leadDays);
      const messageElement = document.getElementById('delivery-estimate-text');
      if (messageElement) {
          messageElement.innerText = `Delivery available before ${formattedDate}`;
      }
  }

  updateDeliveryMessage();
});